module.exports = __webpack_public_path__ + "static/images/d8a7900ff0256b5d2209477a225a8a80.svg";